import { render } from "./FeedbacksList.vue?vue&type=template&id=7e2699b7&ts=true"
import script from "./FeedbacksList.vue?vue&type=script&lang=ts"
export * from "./FeedbacksList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__